var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import { UiButton, UiIcon } from '@claims-ia/design-system';
import DateAndTimePicker from '@declaration/components/UI/DateAndTimePicker.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { areDatesOnSameDay, formatDate, formatDateTime, formatTime, isValidDate, } from '@shared/utils/date';
import { QuestionComponent, QuestionProps } from '@declaration/question';
const claim = namespace('claim');
const qualification = namespace('qualification');
let RobberyAbsenceDatesQuestion = class RobberyAbsenceDatesQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.today = new Date();
        this.startValue = null;
        this.endValue = null;
        this.errorMessage = null;
    }
    created() {
        var _a, _b, _c, _d;
        this.startValue = this.stringToDate((_b = (_a = this.qualification) === null || _a === void 0 ? void 0 : _a.absenceDateTimeInterval) === null || _b === void 0 ? void 0 : _b.start);
        this.endValue = this.stringToDate((_d = (_c = this.qualification) === null || _c === void 0 ? void 0 : _c.absenceDateTimeInterval) === null || _d === void 0 ? void 0 : _d.end);
    }
    onQualificationChange(newVal) {
        var _a, _b;
        this.startValue = this.stringToDate((_a = newVal === null || newVal === void 0 ? void 0 : newVal.absenceDateTimeInterval) === null || _a === void 0 ? void 0 : _a.start);
        this.endValue = this.stringToDate((_b = newVal === null || newVal === void 0 ? void 0 : newVal.absenceDateTimeInterval) === null || _b === void 0 ? void 0 : _b.end);
    }
    onValidation() {
        this.errorMessage = null;
        if (!this.canValidate) {
            this.errorMessage = this.$tc('error.claims.roberry.absence_dates.invalid_dates');
            return;
        }
        this.updateAndSaveQualification({
            step: this.step,
            qualificationPayload: {
                absenceDateTimeInterval: {
                    start: this.startValue.toISOString(),
                    end: this.endValue.toISOString(),
                },
            },
            claimPayload: {
                damageDate: this.endValue.toISOString(),
            },
        });
    }
    get maxStartDate() {
        return this.endValue || this.today;
    }
    get minEndDate() {
        return this.startValue;
    }
    get canValidate() {
        return (isValidDate(this.startValue, { max: this.maxStartDate }) &&
            isValidDate(this.endValue, { min: this.minEndDate }));
    }
    get panelTitle() {
        return this.$tc('claim.qualification.robbery.absence_dates.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.robbery.absence_dates.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        var _a, _b;
        const start = (_a = this.qualification.absenceDateTimeInterval) === null || _a === void 0 ? void 0 : _a.start;
        const end = (_b = this.qualification.absenceDateTimeInterval) === null || _b === void 0 ? void 0 : _b.end;
        if (!start || !end) {
            return null;
        }
        if (areDatesOnSameDay(start, end)) {
            return this.$tc('claim.qualification.robbery.absence_dates.same_day.answer', 0, {
                day: formatDate(start),
                start: formatTime(start),
                end: formatTime(end),
            });
        }
        return this.$tc('claim.qualification.robbery.absence_dates.answer', 0, {
            start: formatDateTime(start),
            end: formatDateTime(end),
        });
    }
    stringToDate(dateString) {
        return dateString ? new Date(dateString) : null;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], RobberyAbsenceDatesQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], RobberyAbsenceDatesQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], RobberyAbsenceDatesQuestion.prototype, "updateAndSaveQualification", void 0);
__decorate([
    Watch('qualification', { deep: true })
], RobberyAbsenceDatesQuestion.prototype, "onQualificationChange", null);
RobberyAbsenceDatesQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton, UiButton, UiIcon, DateAndTimePicker },
        props: QuestionProps,
    })
], RobberyAbsenceDatesQuestion);
export default RobberyAbsenceDatesQuestion;
